import { getDefaultFields } from "../common/common.fields";
import { headingTagInput } from "../presets/inputs";

export const CTA_01_FORM = {
  sectionName: "CTA Section",
  elements: [
    {
      inputType: "list",
      label: "Headings",
      hasStyleProps: false,
      updateTo: "headings",
      mockElements: {
        hasStyleProps: true,
        styleElementId: 1,
        elements: [
          {
            inputType: "textarea",
            label: "Heading",
            defaultValue:
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
            updateTo: "headings[i].text",
            extraPropUpdateTo: "headings[i]",
            extraPropValues: {
              text:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
              styleProps: {
                "text-align": "center",
                "font-size": "1.125rem",
                "line-height": "1.75rem",
                color: "#ffffff",
              },
            },
            hasStyleProps: false,
          },
          headingTagInput({updateTo: "headings[i].tag"}),          
        ],
      },
      elements: [],
    },
    {
      inputType: "select",
      label: "Show Buttons",
      updateTo: "showBtnSec",
      hasStyleProps: false,
      hideLabel: true,
      options: [
        {
          value: true,
          display: "Show",
        },
        {
          value: false,
          display: "Hide",
        },
      ],
    },
    {
      inputType: "list",
      label: "Buttons",
      hasStyleProps: true,
      styleElementId: 2,
      updateTo: "buttons",
      mockElements: {
        hasStyleProps: true,
        styleElementId: 3,
        elements: [
          {
            inputType: "text",
            label: "Button",
            defaultValue: "Click Here",
            updateTo: "buttons[i].text",
            extraPropUpdateTo: "buttons[i]",
            extraPropValues: {
              text: "Click Here",
              styleProps: {
                color: "#ffffff",
                "border-color": "#3b82f680",
              },
            },
            hasStyleProps: false,
          },
          {
            inputType: "text",
            label: "Href",
            defaultValue: "",
            updateTo: "buttons[i].href",
            hasStyleProps: false,
          },         
          {
            inputType: "select",
            label: "Open In",
            defaultValue: "sametab",
            updateTo: "buttons[i].openType",
            hasStyleProps: false,
            options: [
              { value: "sametab", display: "Same Tab" },
              { value: "newtab", display: "New Tab" },
            ],
          },
          {
            inputType: "group",
            label: "Advanced",
            initShow:false,
            elements: [
              {
                inputType: "text",
                label: "Button ID",
                defaultValue: "",
                updateTo: "buttons[i].button_id",
                hasStyleProps: false,
              }, 
              {
                inputType: "text",
                label: "Alt Text",
                defaultValue: "",
                updateTo: "buttons[i].alt",
                hasStyleProps: false,
              },             
            ]
          },
        ],
      },
      elements: [],
    },
    {
      inputType: "componentTag",
      subType: "SubscriptionTag",
      label: "Email Subscription",
      updateTo: "subscription",
      hasStyleProps: true,
      styleElementId: 4,
    },
  ],
  styleElements: [
    {
      styleElementId: 0,
      label: "CTA section",
      elements: [
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "styleProps",
          fields: ["backgroundcolor", "backgroundgradient", "backgroundimage", "padding", "margin"],
        }),
        { inputType: "section", label: "Container" },
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "containerStyleProps",
          fields: [
            "backgroundcolor",
            "borderwidth",
            "bordercolor",
            "borderradius",
            "shadow",
            "padding",
            "margin",
            "maxwidth"
          ],
        }),
      ],
    },
    {
      styleElementId: 1,
      label: "Heading",
      elements: [
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "headings[i].styleProps",
          fields: [            
            "backgroundcolor",
            "color",
            "fontsize",
            "fontweight",
            "fontfamily",
            "letterspacing",
            "padding",
            "margin",
            "textalign",
            "borderwidth",
            "borderradius",
            "bordercolor",
            "shadow"
          ],
        }),
        { inputType: "section", label: "Outer" },
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "headings[i].alignStyleProps",
          fields: [
            "backgroundcolor",
            "borderwidth",
            "bordercolor",
            "borderradius",
            "shadow",
            "textalign",
            "padding",
            "margin",   
            "maxwidth"
          ],
        }),
      ],
    },
    {
      styleElementId: 2,
      label: "Button section",
      elements: [
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "btnSecStyleProps",
          fields: ["padding", "margin"],
        }),
        {
          label: "Align",
          inputType: "select",
          name: "btnSecCenter",
          updateTo: "btnSecStyleProps.justify-content",
          options: [
            {
              value: "left",
              display: "Left",
            },
            {
              value: "center",
              display: "Center",
            },
            {
              value: "right",
              display: "Right",
            },
          ],
        },
      ],
    },
    {
      styleElementId: 3,
      label: "Button",
      elements: [
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "buttons[i].styleProps",
          fields: [
            "color",
            "fontfamily",
            "fontweight",
            "fontsize",
            "backgroundcolor",
            "padding",
            "margin",
            "bordercolor",
            "borderradius",
            "borderwidth",
          ],
        }),
      ],
    },
    {
      styleElementId: 4,
      label: "Email section",
      elements: [
        ...getDefaultFields({
          type: "TEXT",
          updateTo: "emailSecStyleProps",
          fields: ["backgroundcolor", "borderwidth",  "bordercolor",  "borderradius", "padding", "margin"],
        }),
      ],
    },
  ],
};
